<!-- Close button -->
<div class="absolute top-3 right-3">
  <button mat-mini-fab aria-label="Dialog schließen" [mat-dialog-close]="true" color="light" data-test="cancelButton">
    <mat-icon svgIcon="sli-schliessen-gross-20"></mat-icon>
  </button>
</div>
<!-- End close button -->

<!-- Content -->
<h1 class="mb-4 heading-4-sans">{{ 'main-onboarding.title' | translate }}</h1>
<mat-dialog-content>
  <img class="drop-shadow-lg" ngSrc="assets/images/onboarding-main-login-button.png" alt="Anmelde-Schaltfläche"
       height="290" width="784">
  <p class="mt-4">{{ 'main-onboarding.text' | translate }}</p>
</mat-dialog-content>
<!-- End content -->

<!-- Action buttons -->
<mat-dialog-actions class="flex flex-col gap-4 sm:flex-row sm:justify-end">
  <button mat-button color="primary" class="w-full sm:w-0" [mat-dialog-close]="true" data-test="acceptButton">{{ 'main-onboarding.accept_button' | translate }}</button>
</mat-dialog-actions>
<!-- End action buttons -->
